import {AnalyticsEventActions} from '@mintdata-wsp/common/controllers/analytics/AnalyticsEventActions';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {RouteUtil} from '@mintdata-wsp/wsp/ui/routes/RouteUtil';
import {Routing} from '@mintdata-wsp/wsp/ui/routes/Routing';
import * as React from 'react';
import {Redirect, Route, RouteComponentProps, RouteProps} from 'react-router';

export interface IBaseRouteProps extends RouteProps
{
    renderRoute:(routeComponentProps:RouteComponentProps<any>) => JSX.Element;
}

export interface IBaseRouteState
{
    canRenderRoute:boolean;
}

export class BaseRoute extends React.Component<IBaseRouteProps, IBaseRouteState>
{
    public constructor(props:IBaseRouteProps)
    {
        super(props);

        this.state = {
            canRenderRoute: false
        };
    }

    public componentDidMount()
    {
        controllers.user.restoreUserSessionIfNeeded()
            .then((canRenderRoute:boolean) =>
            {
                this.setState({canRenderRoute});
            });
    }

    public render():any
    {
        return <Route {...this.props} render={this._handleRoute} />;
    }

    private _handleRoute = (routeComponentProps:RouteComponentProps<any>):JSX.Element =>
    {
        if( !this.state.canRenderRoute )
        {
            return null;
        }

        const {location} = routeComponentProps;

        controllers.ui.dialogs.hideAll();
        controllers.navigation.setCurrentRouteProps(routeComponentProps);

        if( RouteUtil.needsRedirectToUnsupportedPage(location.pathname) )
        {
            return <Redirect to={{pathname: Routing.paths().unsupported(), state: {from: location}}} />;
        }

        this.checkPathAndSendAnalyticEvents(routeComponentProps);

        return this.props.renderRoute(routeComponentProps);
    };

    private checkPathAndSendAnalyticEvents(routeComponentProps:RouteComponentProps<any>)
    {
        const {prevUrlLanded} = rootState.navigation;

        const pageUrl = (window as Window).location.href;

        if( pageUrl === prevUrlLanded ) return;

        if( prevUrlLanded )
        {
            const {path} = routeComponentProps.match;
            // console.log('%c =================================================', 'background:#0f0;color:#000;');
            // console.log('%c path =', 'background:#0f0;color:#000;', path);

            const fromJoinPage = prevUrlLanded.indexOf('/join/') !== -1 ||
                prevUrlLanded.indexOf('/join-organization/') !== -1;

            // designer
            if( path === '/:projectId/:designId' )
            {
                const {currentOrganization} = rootState.userSession;
                const {projectId, designId} = this._getUrlParams(routeComponentProps);

                controllers.analytics.main.trackEvent(
                    AnalyticsEventActions.WSP_DESIGNER_LANDED,
                    {
                        is_from_wsp: true,

                        org_sid: currentOrganization.siteId,
                        org_name: currentOrganization.name,

                        space_id: projectId,
                        // space_name: currentProject.name,

                        design_id: designId
                        // design_name: design.name,
                    }
                );
            }
            else
            {
                let action:AnalyticsEventActions;

                if( fromJoinPage )
                    action = AnalyticsEventActions.WSP_INVITE_NEW_USER_FIRST_PAGE_LANDED;
                else
                    action = AnalyticsEventActions.WSP_PAGE_LANDED;

                controllers.analytics.main.trackEvent(
                    action,
                    {
                        from_page_url: prevUrlLanded
                    }
                );
            }
        }

        rootState.navigation.prevUrlLoaded = prevUrlLanded;
        rootState.navigation.prevUrlLanded = pageUrl;
    }

    private _getUrlParams(props:RouteComponentProps<any>):{projectId:number, designId:number}
    {
        const {projectId, designId} = props.match.params;

        return {
            projectId: Number(projectId),
            designId: Number(designId)
        };
    }
}
